import { DIPLOMAS_TRANSLATION_KEY } from '../constants';

export default {
  [DIPLOMAS_TRANSLATION_KEY]: {
    // Empty view
    EMPTY_VIEW_TITLE: 'Aún no obtienes un diploma',
    EMPTY_VIEW_DESC:
      'Una vez que completes al 100% tus cursos o aprueben tus proyectos podrás obtener tus diplomas.',
    EMPTY_VIEW_BUTTON: 'Ir a mis proyectos',
    EMPTY_VIEW_DEGREE_DESC:
      'Una vez que completes todos los cursos y entregues tus proyectos parciales, tendrás que avanzar tu proyecto final y aprobarlo para poder obtener tu diploma de MicroDegree.',
    EMPTY_VIEW_DEGREE_BUTTON: 'Ir a mi MicroDegree',
    EMPTY_VIEW_BUTTON_USER_HE: 'Ir a mis rutas',
    // Error view
    DIPLOMAS_ERROR: 'Ocurrió un error al obtener tus diplomas',
    GENERAL_ERROR: 'Ocurrió un error',
    TRY_AGAIN: 'Vuelve a intentarlo',
    INTERNET_CONNECTION_ERROR: 'Ocurrió un error de conexión',
    RELOAD_PAGE: 'Recargar la página',
    CERTIFICATE: 'CERTIFICADO',
    TRACK: 'RUTA',
    CONSTANCE: 'CONSTANCIA',
  },
};
